import * as Yup from "yup";
import { campo_obligatorio } from "../../utils/traductor";

export function initialValues(state) {
  return {
    nombre: state.nombre,
    provinciaestado: state.provinciaestado,
    pais: state.pais,
    activo: state.activo,
  };
}

export function validationSchema() {
  return Yup.object({
    nombre: Yup.string().required(` ${campo_obligatorio} `),
    provinciaestado: Yup.string().required(` ${campo_obligatorio} `),
    pais: Yup.string().required(` ${campo_obligatorio} `),
  });
}
